import Page from 'components/ui/Page'
import PropTypes from 'prop-types'
import React from 'react'
import { useParams } from 'react-router-dom'
import MatchView from './MatchView'

const MatchViewPage = () => {
    const { id } = useParams()
    return (
        <Page title="Matches">
            <MatchView matchId={id} />
        </Page>
    )
}

MatchViewPage.propTypes = {
    matchId: PropTypes.any,
}

export default MatchViewPage
